/* Gallery position dots for the PDP v3 size-finder template.
 * The reference design (agents/reference/pdp-redesign-v3.html) has no
 * thumbnail strip — dot indicators over the hero show there are more
 * images, like the collection-card dots. The dots track the active slide
 * via the media-gallery's own events: swipes dispatch
 * 'on:carousel-slider:select' (detail.slide carries the media id) and any
 * programmatic change (variant featured media, zoom viewer) ends in
 * setActiveMedia(), which fires 'on:media-gallery:change'.
 */
(() => {
  class PdpGalleryDots extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.gallery = this.closest('media-gallery');
      if (!this.gallery) return;

      this.syncHandler = this.sync.bind(this);
      this.gallery.addEventListener('on:carousel-slider:select', this.syncHandler);
      this.gallery.addEventListener('on:media-gallery:change', this.syncHandler);
    }

    sync(evt) {
      const mediaId = evt.type === 'on:carousel-slider:select'
        ? evt.detail.slide.dataset.mediaId
        : this.gallery.querySelector('.main-image .slider__item.is-active')?.dataset.mediaId;
      if (!mediaId) return;

      this.querySelectorAll('.product-block__image-dot').forEach((dot) => {
        dot.classList.toggle('product-block__image-dot--active', dot.dataset.mediaId === mediaId);
      });
    }
  }

  if (!window.customElements.get('pdp-gallery-dots')) {
    window.customElements.define('pdp-gallery-dots', PdpGalleryDots);
  }
})();
